import { matchPath, useLocation } from 'react-router-dom';

import { PageViewedTracker, useClickstream } from '@zenbusiness/application-commons-clickstream';

import * as ROUTES from '#client/constants/routes';
import { getAppOrigin } from '#client/utils/getAppOrigin';
import { getAppSection } from '#client/utils/getAppSection';

export default function TrackView() {
  const { pathname } = useLocation();
  const { ready: isInitialized } = useClickstream();

  if (!isInitialized || !pathname || pathname === ROUTES.callback) {
    return null;
  }

  // These routes fire their own PageViewedTracker with custom appPageName + dynamicProperties
  // (billing payment methods: ecommerce-ui's PaymentMethodsManagement, ECOMM-2768)
  if (
    matchPath(ROUTES.invoicePayment, pathname) ||
    matchPath(ROUTES.invoicePaymentReturn, pathname) ||
    matchPath(ROUTES.billingPaymentMethods, pathname) ||
    matchPath(ROUTES.entityBillingPaymentMethods, pathname)
  ) {
    return null;
  }

  const appSection = getAppSection(pathname);

  return (
    <PageViewedTracker
      appOrigin={getAppOrigin(pathname)}
      appSection={appSection}
      experienceOrigin="dashboard"
      // !Note: Do not remove the "key" prop. The key prop is used to force the component to re-render when the pathname changes allowing the track event to be fire on each page load.
      key={pathname}
    />
  );
}
